export default __webpack_public_path__ + "static/media/linkedin-original.79a60cae.svg";